export interface KeyValueMap {
  [key: string]: any;
}
